module.exports = __webpack_public_path__ + "logo2016cuadrado_sinfondo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2016cuadrado_sinfondo.png
// module id = 180
// module chunks = 0